const unitsToRem = (size: number) => {
  return `calc((((100vw + 100vh) / 2) / 141) * ${size})`;
};

export default unitsToRem;
